<template>
    <hts-drawer
        v-model="visible"
        :title="$t('labels.addAssumption')"
        :rules="rulesAssumptionCosting"
        :submit="submit"
        @close="close">
        <div
            v-if="visible"
            class="grid gap-4 grid-cols-1">
            <hts-select-category-vehicle
                v-model="formData.categoryVehicle"
                v-model:name="formData.categoryVehicleName"
                :label="$t('labels.vehicleType')"
                required
                prop="vehicleCategory" />
            <hts-form-input
                v-model="formData.indicator"
                :label="$t('labels.indicator')"
                type="number"
                required
                prop="indicator"
                name="indicator" />
            <hts-form-select
                v-model="formData.name"
                :label="$t('labels.nameAssumption')"
                :items="listNameAssumption"
                required
                key-id="key"
                key-label="title"
                prop="nameAssumption"
                name="nameAssumption" />
        </div>
        <template #footer>
            <div class="flex flex-row gap-5">
                <hts-form-button
                    icon-name="hi-check-icon"
                    icon-position="right"
                    color="primary"
                    type="submit"
                    :loading="creating">
                    {{ $t('labels.save') }}
                </hts-form-button>

                <hts-form-button
                    icon-name="hi-x-mark-icon"
                    icon-position="right"
                    color="error"
                    @click="visible = false">
                    {{ $t('labels.cancel') }}
                </hts-form-button>
            </div>
        </template>
    </hts-drawer>
</template>

<script setup lang="ts">
import { ICreateCostingAssumption } from '~/pages/trucker-[id]/cost/ignore/imports/form'

const rulesAssumptionCosting = {
  nameAssumption: 'required',
  indicator: 'required|numeric'
}
const visible = ref(false)
const creating = ref(false)
const resetForm = () => {
  Object.assign(formData, {
    name: '',
    categoryVehicle: '',
    categoryVehicleName: '',
    indicator: ''
  })
}
const formData = reactive<ICreateCostingAssumption>({
  name: '',
  categoryVehicle: '',
  categoryVehicleName: '',
  indicator: ''
})
const close = () => {
  resetForm()
  visible.value = false
}

const emits = defineEmits(['refreshTables'])

const open = () => {
  visible.value = true
}
defineExpose({
  open
})

const submit = () => {
  const api = $url.cost.assumption.createAssumption
  creating.value = true
  $api(api, { body: formData })
    .then((data: any) => {
      if (!data) {
        return true
      }
      const responseData: any = data.data.value
      if (responseData.success) {
        resetForm()
        process.client && $toast().success($t('labels.addAssumptionSuccess'))
      }
      emits('refreshTables')
      creating.value = false
      visible.value = false
    })
    .catch(() => {
      creating.value = false
      visible.value = false
      resetForm()
    })
}

const listNameAssumption = [
  {
    key: 'ASSUMPTION_GASOLINE',
    title: $t('labels.assumptionGasoline')
  }
]
</script>
